import { render, staticRenderFns } from "./UploadExpensePage.vue?vue&type=template&id=56a9a585"
import script from "./UploadExpensePage.vue?vue&type=script&lang=js"
export * from "./UploadExpensePage.vue?vue&type=script&lang=js"
import style0 from "./UploadExpensePage.vue?vue&type=style&index=0&id=56a9a585&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports